import React, { useState } from "react";
import clsx from "clsx";
import { CardMedia, CardHeader, CardContent, CardActions } from "@material-ui/core/";
import { Collapse, IconButton, Typography, Card } from "@material-ui/core/";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Option from "./Option";
import useStyles from "../../../assets/cardStyles";
import formatMoney from "../../../utils/formatMoney";

export default function SubCategory(props) {
	const { data } = props;
	const classes = useStyles();
	const [isExpanded, setIsExpanded] = useState(false);

	const handleExpandClick = () => {
		setIsExpanded(!isExpanded);
	};
	const hasOptions = data.hasOwnProperty("options");
	const hasPrice = data.hasOwnProperty("price");
	const hasMultipleOptions = data.hasOwnProperty("optionsAmount");

	const optionsDetailed = hasMultipleOptions && (
		<>
			<Typography variant="body2" paragraph>
				Opciones que se pueden elegir: {data.optionsAmount}
			</Typography>
			<Typography variant="body2" paragraph>
				Cantidad de veces que puedes repetir: {data.sameOptionMaxAmount}
			</Typography>
		</>
	);

	const required = data.required && (
		<Typography variant="body2" paragraph>
			Requerido
		</Typography>
	);

	const price = hasPrice && (
		<Typography variant="body2" paragraph>
			precio: {formatMoney(data.price)}
		</Typography>
	);

	return (
		<Card className={classes.root2}>
			{data.imgUrl ? <CardMedia className={classes.mediaSecundary} image={data.imgUrl} title={data.name} /> : null}
			<CardHeader className={classes.smallPadding} title={data.name} />
			<CardContent className={classes.smallPadding}>
				<Typography variant="body2" paragraph>
					{data.description}
				</Typography>
				{required}
				{optionsDetailed}
				{price}
			</CardContent>
			{hasOptions && (
				<>
					<CardActions disableSpacing>
						<IconButton
							className={clsx(classes.expand, {
								[classes.expandOpen]: isExpanded,
							})}
							onClick={handleExpandClick}
							aria-expanded={isExpanded}
							aria-label="show more"
						>
							<ExpandMoreIcon />
						</IconButton>
					</CardActions>
					<CardContent className={classes.smallPadding}>
						<Collapse in={isExpanded} timeout="auto" unmountOnExit>
							{data.options.map((option, index) => (
								<Option key={`option${index}`} data={option} />
							))}
						</Collapse>
					</CardContent>
				</>
			)}
		</Card>
	);
}
